import React, { useState, useEffect, useRef } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Button, Dialog, DialogContent, DialogActions, Select, MenuItem, TextField, Divider, FormHelperText, Drawer, List, ListItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

import { resizeImageInBlob, resizeImageInBase64 } from '../../../utils/imgUtil'
import ValidatedTextInput from '../../top-panel/unauthorized-controls/ValidatedTextInput'

const tabTypes = {
  general: 'general',
  additionally: 'additionally',
}

const styles = theme => ({
  formHeader: {
    paddingLeft: `${theme.spacing.unit * 3}px`
  },
  formGroup: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: `${theme.spacing.unit}px 0`
  },
  label: {
    margin: 'auto 0',
    width: 120
  },
  input: {
    width: 400
  },
  textField: {
    width: 400
  },
  inputPrice: {
    width: 200
  },
  bannerInput: {
    width: '100%'
  },
  bannerPreview: {
    height: 200,
    width: 'auto',
    maxWidth: 400
  },
  dollar: {
    margin: 'auto 0',
    marginLeft: 5
  },
  durationSelect: {
    margin: `0 ${theme.spacing.unit}px`
  },
  bottomButtonGroup: {
    margin: `0 ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px 0`
  },
  errorHelperText: {
    color: 'red'
  },
  formControl: {
  },
  drawerWrapper: {
    width: 400,
    height: 60,
    position: 'relative',
  },
  drawerProps: {
    position: 'absolute',
    width: 400
  },
  listStyle: {
    display: 'flex',
    justifyContent: 'row'
  },
})

const AddStreamDialog = ({ classes, categories, open, onClose, onSubmit, editingStream, updateMyEvent }) => {
  const { t } = useTranslation()

  const drawerContainer = useRef(null)

  // stores the currently chosen banner image
  const [banner, setBanner] = useState({})
  const handleBannerInputChange = async (event) => {
    let file = event.target.files[0]
    const name = 'image-for-base64' + // Concat with file extension.
        file.name.substring(file.name.lastIndexOf('.'))
    // Instantiate copy of file, giving it new name.
    file = new File([file], name, { type: file.type })
    setBanner({
      blob: await resizeImageInBlob(event.target.files[0], 640, 300), // bytes array to be send with API call
      base64: await resizeImageInBase64(file, 640, 300) // to base 64 for save link in redux
    })
  }

  // active tab type
  const [activeTab, setActiveTab] = useState(tabTypes.general)

  // stores the currently selected category
  const [categoryId, setCategoryId] = useState('')
  const handleSelectChange = (event) => setCategoryId(event.target.value)

  // stores the title
  const [title, setTitle] = useState('')
  const handleTitleChange = (value) => {
    if (!value) {
      setValidationErrors({ ...validationErrors, title: t('Cabinet:title is required') })
    } else {
      setValidationErrors({ ...validationErrors, title: undefined })
    }
    setTitle(value)
  }

  // stores the description
  const [description, setDescription] = useState('')
  const handleDescriptionChange = (value) => {
    if (!value) {
      setValidationErrors({ ...validationErrors, description: t('Cabinet:description is required') })
    } else {
      setValidationErrors({ ...validationErrors, description: undefined })
    }
    setDescription(value)
  }

  // stores the program of stream
  const [program, setProgram] = useState('')
  const handleProgramOfStreamChange = (value) => {
    setProgram(value)
  }

  // stores the for whom of stream
  const [forWhom, setForWhom] = useState('')
  const handleForWhomFieldChange = (value) => {
    setForWhom(value)
  }

  // stores the after stream of stream
  const [afterStream, setAfterStream] = useState('')
  const handleAfterStreamFieldChange = (value) => {
    setAfterStream(value)
  }

  // stores the startDate
  const [startDate, setStartDate] = useState(dayjs().format('YYYY-MM-DDTHH:mm'))
  const handleStartDateChange = (value) => {
    if (!value) {
      setValidationErrors({ ...validationErrors, startDate: t('Cabinet:start date is required') })
    } else {
      setValidationErrors({ ...validationErrors, startDate: undefined })
    }
    setStartDate(value)
  }

  // stores the value of hours select in duration input
  const [durationHours, setDurationHours] = useState('1')
  const handleDurationHoursChange = (event) => setDurationHours(event.target.value)

  // stores the value of minutes select in duration input
  const [durationMinutes, setDurationMinutes] = useState('0')
  const handleDurationMinutesChange = (event) => setDurationMinutes(event.target.value)

  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);
  // stores the price of stream
  const [price, setPrice] = useState('100')
  const handlePrivceChange = (value) => {
    let number = parseInt(value);
    if (!number) {
      setValidationErrors({ ...validationErrors, price: t('Cabinet:price is required') })
      number = 0
    } else {
      setValidationErrors({ ...validationErrors, price: undefined })
    }
    setPrice(number);
  }

  // is setting update
  const [isDefaulteSetting, setIsDefaulteSettign] = useState(false)

  // validation Inputs
  const [validationErrors, setValidationErrors] = useState({})

  // editing settings set default
  useEffect(() => {
    if (editingStream && !isDefaulteSetting) {
      setTitle(editingStream.title)
      setDescription(editingStream.description || '')
      setStartDate(dayjs(`${editingStream.startDate}Z`).format('YYYY-MM-DDTHH:mm'))
      setCategoryId(editingStream.categoryId)
      setBanner({ base64: `data:image/png;base64,${editingStream.avatarBytes}`, blob: null })
      setPrice(editingStream.price)
      setIsDefaulteSettign(true)
      setDurationHours(Math.floor(editingStream.duration / 60))
      setDurationMinutes(editingStream.duration % 60)
      setAfterStream(editingStream.afterStream)
      setForWhom(editingStream.forWhom)
      setProgram(editingStream.program)
    }
    if (!banner.base64 ||
      !categoryId ||
      !title ||
      !description ||
      !startDate ||
      !price) {
      setSubmitButtonDisabled(true)
    } else {
      setSubmitButtonDisabled(false)
    }
  })

  // consts to be mapped into duration select values
  const minutesItems = ['0', '10', '20', '30', '40', '50']
  const hoursItems = ['0', '1', '2', '3']

  const handleSubmit = () => {
    const startDate0UTC = new Date(startDate)
    const resultDate = startDate0UTC.toISOString().slice(0, 19)
    if (editingStream) {
      updateMyEvent({
        streamId: editingStream.id,
        categoryId,
        title,
        description,
        startDate: resultDate,
        duration: Number(durationHours) * 60 + Number(durationMinutes),
        avatarBytes: banner.blob,
        avatarPreview: banner.base64,
        price,
        program,
        forWhom,
        afterStream
      })

    } else {
      onSubmit({
        categoryId,
        title,
        description,
        startDate: resultDate,
        duration: Number(durationHours) * 60 + Number(durationMinutes),
        avatarBytes: banner.blob,
        avatarPreview: banner.base64,
        price,
        program,
        forWhom,
        afterStream
      })
    }
    clearData() // set default values of store
    onClose() // hiding dialog after submit
  }

  const clearData = () => {
    setTitle('')
    setDescription('')
    setStartDate(dayjs().format('YYYY-MM-DDTHH:mm'))
    setCategoryId('')
    setBanner({})
    setDurationHours('1')
    setDurationMinutes('0')
    setIsDefaulteSettign(false)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true}>

      <h2 className={classes.formHeader}>{(editingStream) ? t('Cabinet:edit stream') : t('Cabinet:create stream')}</h2>

      <div className={classes.drawerWrapper}
        ref={drawerContainer}>
        <Drawer
          variant='permanent'
          PaperProps={{ className: classes.drawerProps }} // required to keep Drawer in div
          BackdropProps={{ className: classes.drawerProps }} // the same
          ModalProps={{ // the same, as well
            container: drawerContainer.current,
            style: { position: 'absolute' }
          }}>
          <List className={classes.listStyle} >
            <ListItem
              button
              selected={activeTab === tabTypes.general}
              onClick={() => setActiveTab(tabTypes.general)}
            >
              {t('Cabinet:Basic data')}
            </ListItem>
            <ListItem
              button
              selected={activeTab === tabTypes.additionally}
              onClick={() => setActiveTab(tabTypes.additionally)}
            >
              {t('Cabinet:Additionally')}
            </ListItem>
          </List>
        </Drawer>
      </div>
      <Divider variant='fullWidth' />
      {
        (activeTab === tabTypes.general) ? (<DialogContent>

          {/* Banner upload */}
          <div className={classes.formGroup}>
            <label className={classes.label}>{t('Cabinet:banner')}</label>

            <div className={classes.input}>
              <input
                accept='image/*'
                id='contained-button-file'
                type='file'
                onChange={handleBannerInputChange}
                className={classes.bannerInput}
              />

              { // show banner preview, only when image is chosen
                banner.base64
                  ? (<img src={banner.base64} className={classes.bannerPreview} alt='' />)
                  : undefined
              }
            </div>
          </div>

          {/* Category select */}
          <div className={classes.formGroup}>
            <label className={classes.label}>{t('Cabinet:category')}</label>

            <Select className={classes.input}
              value={categoryId}
              onChange={handleSelectChange}>
              {categories.map(category => (
                <MenuItem value={category.id} key={category.id}>{category.name}</MenuItem>
              ))}
            </Select>
          </div>

          {/* Title input */}
          <div className={classes.formGroup}>
            <label className={classes.label}>{t('Cabinet:title')}</label>
            <div>
              <ValidatedTextInput
                classes={classes}
                value={title}
                onChange={handleTitleChange}
                validationError={validationErrors.title}
              />
            </div>
          </div>

          {/* Description input */}
          <div className={classes.formGroup}>
            <label className={classes.label}>{t('Cabinet:description')}</label>
            <ValidatedTextInput
              classes={classes}
              value={description}
              onChange={handleDescriptionChange}
              multiline
              validationError={validationErrors.description}
            />
          </div>

          {/* Start date/time picker */}
          <div className={classes.formGroup}>
            <label className={classes.label}>{t('Cabinet:start time')}</label>
            <ValidatedTextInput
              classes={classes}
              value={startDate}
              onChange={handleStartDateChange}
              type='datetime-local'
              validationError={validationErrors.startDate}
            />
          </div>

          {/* Price of stream field */}
          <div className={classes.formGroup}>
            <label className={classes.label}>{t('Cabinet:price')}</label>
            <ValidatedTextInput
              classes={classes}
              className={classes.inputPrice}
              value={price}
              onChange={handlePrivceChange}
              multiline
              variant='outlined'
              inputProps={{
                style: { textAlign: 'right' }
              }}
              validationError={validationErrors.price}
            />
            <label className={classes.dollar}>{'$'}</label>
          </div>

          {/* Duration time picker */}
          <div className={classes.formGroup}>
            <label className={classes.label}>{t('Cabinet:duration')}</label>

            <div className={classes.input}>
              {/* Duration hours select */}
              <Select id='duration-hours'
                className={classes.durationSelect}
                value={durationHours}
                onChange={handleDurationHoursChange}>
                {hoursItems.map(hours => (
                  <MenuItem value={hours} key={`h${hours}`}>{hours}</MenuItem>
                ))}
              </Select>
              <label htmlFor='duration-hours'>{
                durationHours === '1' // showing singular form of word "hour"
                  ? t('Cabinet:hour')
                  : t('Cabinet:hours')
              }</label>

              {/* Duration minutes select */}
              <Select id='duration-minutes'
                className={classes.durationSelect}
                value={durationMinutes}
                onChange={handleDurationMinutesChange}>
                {minutesItems.map(minutes => (
                  <MenuItem value={minutes} key={`m${minutes}`}>{minutes}</MenuItem>
                ))}
              </Select>
              <label htmlFor='duration-minutes'>{t('Cabinet:minutes')}</label>
            </div>

          </div>

        </DialogContent>) : (
          <DialogContent>

            {/* Description input */}
            <div className={classes.formGroup}>
              <label className={classes.label}>{t('TopBar:stream program')}</label>
              <ValidatedTextInput
                classes={classes}
                value={program}
                onChange={handleProgramOfStreamChange}
                multiline
                validationError={undefined}
              />
            </div>

            {/* Description input */}
            <div className={classes.formGroup}>
              <label className={classes.label}>{t('TopBar:for whom')}</label>
              <ValidatedTextInput
                classes={classes}
                value={forWhom}
                onChange={handleForWhomFieldChange}
                multiline
                validationError={undefined}
              />
            </div>

            {/* Description input */}
            <div className={classes.formGroup}>
              <label className={classes.label}>{t('TopBar:after stream')}</label>
              <ValidatedTextInput
                classes={classes}
                value={afterStream}
                onChange={handleAfterStreamFieldChange}
                multiline
                validationError={undefined}
              />
            </div>

          </DialogContent>
        )
      }

      {/* Bottom button group */}
      <DialogActions className={classes.bottomButtonGroup}>
        {/* Create stream button */}
        <Button
          disabled={submitButtonDisabled}
          onClick={handleSubmit}
          variant='contained'
          color='primary'
        >
          {(editingStream) ? t('Cabinet:save changes') : t('Cabinet:create stream')}
        </Button>

        {/* Close dialog button */}
        <Button
          onClick={() => {
            clearData()
            onClose()
          }}
          variant='contained'
        >
          {t('Cabinet:close')}
        </Button>
      </DialogActions>

    </Dialog>
  )
}

export default withStyles(styles)(AddStreamDialog)
